const MassiveDownloadRoutes = [
  {
    path: '/massive-download',
    name: 'MassiveDownload',
    component: () => import('@/app/massive_download/TheMassiveDownload'),
    redirect: '/massive-download/',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        component: () => import('@/app/massive_download/views/TheMassiveDownloadIndex')
      },
      {
        path: 'new-report',
        name: 'newReport',
        component: () => import('@/app/massive_download/views/TheMassiveDownloadNewReport')
      },
      {
        path: 'favourites',
        name: 'favouriteConfigList',
        component: () => import('@/app/massive_download/views/TheMassiveDownloadFavourites')
      }
    ]
  }
]

export default MassiveDownloadRoutes



// WEBPACK FOOTER //
// ./src/app/massive_download/MassiveDownloadRoutes.js